import { Form, Input } from "antd";

const FormInput = ({
  label,
  name,
  rules = [],
  validateTrigger = "onBlur",
  style = {},
  placeholder = "",
  hasFeedback = false, // handles the checkmark on the field: ask client
  className,
  ...rest
}) => {
  return (
    <Form.Item
      label={label}
      name={name}
      hasFeedback={hasFeedback}
      validateTrigger={validateTrigger}
      rules={rules}
      style={style}
    >
      <Input placeholder={placeholder} className={`p-3 rounded-xl ${className}`} {...rest} />
    </Form.Item>
  );
};

export default FormInput;
